// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__LiBYL","hero":"styles_hero__Dpz6g","h1":"styles_h1__7K2ma"};